import React, { createContext, PropsWithChildren } from 'react'

import { PropRental } from '@guiker/prop-rental-shared'
import { generateUseContext, useQuery } from '@guiker/react-framework'

import { useAdminPropRentalContext } from '../admin'

type PropRentalProviderProps = PropsWithChildren & {
  listingId?: string
}

type PropRentalContext = {
  data: PropRental
}

const PropRentalContext = createContext<PropRentalContext>(null)

export const PropRentalContextProvider: React.FC<PropRentalProviderProps> = ({ children, listingId }) => {
  const { apiClient } = useAdminPropRentalContext()
  const queryKey = ['propRental', listingId]
  const { data } = useQuery<PropRental>(
    queryKey,
    (_) => apiClient.readOnePropRentalByListingId({ pathParams: { listingId } }),
    {
      enabled: !!listingId,
      retry: 1,
    },
  )
  return <PropRentalContext.Provider value={{ data }}>{children}</PropRentalContext.Provider>
}

export const usePropRental = generateUseContext(PropRentalContext)
